import $ from 'jquery';

export default class Lightbox {

  constructor(el) {
    this.el = el;
    this.lightBoxSrc = $('.js-lightbox_src');
    this.lightBoxVideoContainer = $('.js-lightbox_video-container');
    this.lightBoxVideoSrc = $('.js-lightbox_video-src');
    this.lightBoxDest = el.find('.js-lightbox_img');

    this.handleEvents();
  }

  handleEvents() {
    let self = this;

    this.lightBoxDest.click(e => e.stopPropagation());
    this.lightBoxSrc.click(this.openLightBoxWithImage(self));
    this.lightBoxVideoSrc.click(this.openLightBoxWithVideo(self));
    this.el.click(() => {
      this.toggleLightbox();
      this.removeVideo();
    });
  }

  openLightBoxWithImage(self) {
    return function (e) {
      self.insertImageFrom(e.target);
      self.insertAltDescription(e.target);
      self.toggleLightbox();
    }
  }

  openLightBoxWithVideo(self) {
    return function (e) {
      self.insertVideoFrom(e.target);
      self.toggleLightbox();
    }
  }

  insertImageFrom(imgClicked) {
    this.lightBoxDest.attr(
      'src',
      $(imgClicked).attr('data-src')
    ).show();

    this.lightBoxVideoContainer.hide();
  }

  insertVideoFrom(imgClicked) {
    this.lightBoxVideoContainer.html(
      this.getIframeFragment(imgClicked)
    );

    this.lightBoxDest.hide();
    this.lightBoxVideoContainer.show();
  }

  getIframeFragment(element) {
    let iFrameRef = $(element).attr('data-video-ref');

    return $('[data-ref='+iFrameRef+']').html();
  }

  removeVideo() {
    this.lightBoxVideoContainer.html('');
  }

  insertAltDescription(imgClicked) {
    this.lightBoxDest.attr(
      'alt',
      $(imgClicked).attr('data-src-alt')
    );
  }

  toggleLightbox() {
    this.el.toggleClass('is-opened');
  }
}


// WEBPACK FOOTER //
// ./src/components/lightbox/lightbox.js